import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { APP_FILE_QUOTES_LIST_ROUTE, APP_FILE_QUOTES_ROUTE } from "./Quotes.constants";
import { MODULE_IDS } from "../../constants/enums";
const QuotesList = Loadable(
  lazy(() =>
    import("./QuotesList").then(({ QuotesList }) => ({
      default: QuotesList,
    }))
  )
);
const Quotes = Loadable(
  lazy(() =>
    import("./Quotes").then(({ Quotes }) => ({
      default: Quotes,
    }))
  )
);
export const qoutesRoutes = [
  {
    path: `${APP_FILE_QUOTES_LIST_ROUTE}`,
    exact: true,
    element: (
      <AuthorizedRoute  moduleKeys={[MODULE_IDS.QUOTES]}>
        <QuotesList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_QUOTES_ROUTE}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.CUSTOMER]}>
        <Quotes />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_QUOTES_ROUTE}/:quoteId`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.CUSTOMER]}>
        <Quotes />
      </AuthorizedRoute>
    ),
  },
];
